import { render } from "./LesAmisPage.vue?vue&type=template&id=b8d66112"
import script from "./LesAmisPage.vue?vue&type=script&lang=js"
export * from "./LesAmisPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__